import React from "react";
import BarCandles from "@/components/BarCandles";
import { CatListDropdown } from "@/components/FileInput";

const AnnualSPXReturns = ({
  selectedType,
  regimeBar,
  regimeBarForNocrash,
  firstAsset,
  firstAssetName,
  firstAssetDropdown,
  handleFirstAsset,
}) => {
  return (
    <div className="grid grid-cols-12 gap-2 lg:gap-5">
      <div className="col-span-12 sm:col-span-7 bg-white rounded-lg shadow-xl shadow-slate-300 p-5">
        {(selectedType === "normal" || selectedType === "reshuffle") && (
          <BarCandles
            dataset={regimeBar}
            title={{
              x: "Annual " + firstAssetName + " Returns",
              y: "Num of Years",
            }}
          />
        )}
        {selectedType === "nocrash" && (
          <BarCandles
            dataset={regimeBarForNocrash}
            title={{
              x: "Annual " + firstAssetName + " Returns",
              y: "Num of Years",
            }}
          />
        )}
      </div>
      <div className="col-span-12 sm:col-span-5">
        <div className="text-sm">
          <CatListDropdown
            id={"FirstAssetDropdown"}
            className={
              "m-0 mb-2 border border-gray-300 rounded-md px-2 h-8 py-1 text-black text-sm"
            }
            value={firstAsset}
            options={firstAssetDropdown}
            onChange={handleFirstAsset}
            data-testid="main-returns-first-asset-select" />
        </div>
      </div>
    </div>
  );
};

export default AnnualSPXReturns;
